module.exports = __webpack_public_path__ + "img/wko-handwerk-stmk.54ef8109.svg";